import { useState, useEffect } from "react";
import { supabase } from "../auth/supabaseClient";
import { useAuth } from "../../contexts/AuthContext";
import {
  AiOutlineLoading3Quarters,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
} from "react-icons/ai";

function TableRowMember(props) {
  const [loading, setLoading] = useState(true);
  const [memberProfile, setMemberProfile] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(
    "https://ribbon-public-assets.s3.amazonaws.com/temp-image.png"
  );
  const [role, setRole] = useState(props.member.role);

  useEffect(() => {
    if (props.member) {
      fetchMemberProfile(props.member.user_id);
    }
  }, [props.member]);

  useEffect(() => {
    if (memberProfile) {
      downloadProfileImage(memberProfile.photo_url);
    }
  }, [memberProfile]);

  const fetchMemberProfile = async (member_id) => {
    setLoading(true);
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", member_id)
      .single();
    if (error) {
      console.log(error);
    } else {
      setMemberProfile(data);
      setLoading(false);
    }
  };

  function MemberRole(props) {
    const updateMember = async (role) => {
      if (role === "remove") {
        const { data, error } = await supabase
          .from("team_membership")
          .delete()
          .eq("id", props.member.id);
        if (error) {
          console.log(error);
        } else {
          setRole("remove");
        }
      } else {
        const { data, error } = await supabase
          .from("team_membership")
          .update({ role: role })
          .eq("id", props.member.id); // N.B. this is an id for the team_membership table, not the user_id

        if (error) {
          console.log(error);
        } else {
          setRole(role);
        }
      }
    };

    if (role === "admin") {
      return <div className="text-green-500 ">Admin</div>;
    } else if (role === "member") {
      return <div className="text-gray-500">Member</div>;
    } else if (role === "unapproved-member") {
      return (
        <div className="flex items-center justify-center">
          <p className="text-red-500">Pending</p>
          <button onClick={() => updateMember("member")}>
            <AiOutlineCheckCircle className="inline ml-1" />
          </button>
          <button onClick={() => updateMember("remove")}>
            <AiOutlineCloseCircle className="inline ml-1" />
          </button>
        </div>
      );
    }
  }

  const downloadProfileImage = async (photoUrl) => {
    try {
      const { data, error } = await supabase.storage
        .from("avatars")
        .download(photoUrl);
      if (error) {
        throw error;
      }
      const url = URL.createObjectURL(data);
      setProfileImageUrl(url);
    } catch (error) {
      console.log("Error downloading image: ", error.message);
    }
  };

  if (role === "remove") {
    return null;
  }

  if (loading) {
    return (
      <tr>
        <td className="p-2 whitespace-nowrap">
          <div className="flex items-center">
            <div className="w-10 h-10 flex-shrink-0 mr-2 sm:mr-3">
              <AiOutlineLoading3Quarters className="animate-spin" />
            </div>
            <AiOutlineLoading3Quarters className="animate-spin" />
          </div>
        </td>
        <td className="p-2 whitespace-nowrap">
          <AiOutlineLoading3Quarters className="animate-spin" />
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td className="p-2 whitespace-nowrap">
        <div className="flex items-center">
          <div className="w-10 h-10 flex-shrink-0 mr-2 sm:mr-3">
            <img
              className="rounded-full"
              src={profileImageUrl}
              width="40"
              height="40"
              alt="Alex Shatov"
            />
          </div>
          <div className="font-medium text-gray-800">
            {memberProfile.first_name + " " + memberProfile.last_name}
          </div>
        </div>
      </td>
      <td className="p-2 whitespace-nowrap">
        <div className="text-center">
          <MemberRole member={props.member} />
        </div>
      </td>
    </tr>
  );
}

function TeamTable(props) {
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    if (props.activeTeam) {
      fetchTeamMembers(props.activeTeam);
    }
  }, [props.activeTeam]);

  const fetchTeamMembers = async (team_id) => {
    const { data, error } = await supabase
      .from("team_membership")
      .select("*")
      .eq("team_id", team_id);

    console.log("team members 2", data);
    if (error) {
      console.log(error);
    }
    setTeamMembers(data);
  };

  return (
    <section className="antialiased text-gray-600 px-4">
      <div className="flex flex-col justify-center h-full">
        <div className="w-full max-w-2xl mx-auto bg-white shadow-lg rounded-sm border border-gray-200">
          <header className="px-5 py-4 border-b border-gray-100">
            <h2 className="font-semibold text-gray-800">Members</h2>
          </header>
          <div className="p-3">
            <div className="overflow-x-auto">
              <table className="table-auto w-full">
                <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                  <tr>
                    <th className="p-2 whitespace-nowrap">
                      <div className="font-semibold text-left">Name</div>
                    </th>
                    <th className="p-2 whitespace-nowrap">
                      <div className="font-semibold text-center">Role</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-100">
                  {teamMembers &&
                    teamMembers.map((member) => (
                      <TableRowMember key={member.id} member={member} />
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Team() {
  const { user } = useAuth();

  const [loading, setLoading] = useState(true);
  const [teamsMemberIsAdminOf, setTeamsMemberIsAdminOf] = useState([]);

  const [activeTeam, setActiveTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    setLoading(true);
    if (user) {
      fetchTeamsMemberIsAdminOf();
    }
    setLoading(false);
  }, [user]);

  const fetchTeamsMemberIsAdminOf = async () => {
    const { data, error } = await supabase
      .from("team_membership")
      .select("*")
      .eq("user_id", user.id)
      .eq("role", "admin");

    console.log("teamsMemberIsAdminOf: ", data);
    setTeamsMemberIsAdminOf(data);

    // set the default active team to the first team in the list
    if (data.length > 0) {
      setActiveTeam(data[0].team_id);
    }
  };

  return <TeamTable activeTeam={activeTeam} />;
}
